var map = {
	"./1000+.png": 162,
	"./404.png": 163,
	"./BookReader.png": 164,
	"./Booknet.png": 165,
	"./BravoFiction.png": 166,
	"./CamelNovel.png": 167,
	"./Chapters.png": 168,
	"./CoralReader.png": 169,
	"./CornReading.png": 170,
	"./DailyBooks.png": 171,
	"./DeerFiction.png": 172,
	"./DolphinReader.png": 173,
	"./Dreams.png": 174,
	"./FICTLF.png": 175,
	"./FancyNovel.png": 176,
	"./FicFun.png": 177,
	"./FicWorld.png": 178,
	"./FictionFlow.png": 179,
	"./FoxFics.png": 180,
	"./FoxFm.png": 181,
	"./Free2Read.png": 182,
	"./FreeRead.png": 183,
	"./FunFic.png": 184,
	"./FunNovel.png": 185,
	"./FunStory-android.png": 186,
	"./Gonovel.png": 187,
	"./GoodFiction.png": 188,
	"./GoodStory.png": 189,
	"./GoodToon.png": 190,
	"./GrapeNovel.png": 191,
	"./HeyRead.png": 192,
	"./HippoNovel.png": 193,
	"./HitNovel.png": 194,
	"./Hitfic.png": 195,
	"./HotNovel.png": 196,
	"./IHear.png": 197,
	"./Inkspired.png": 198,
	"./Inkwell.png": 199,
	"./KiWiReader.png": 200,
	"./Kiwi.png": 201,
	"./LemonRead.png": 202,
	"./LetsRead.png": 203,
	"./Libfic.png": 204,
	"./Liby.png": 205,
	"./LionFiction.png": 206,
	"./Listenow.png": 207,
	"./LoveNovel.png": 208,
	"./LoveRead.png": 209,
	"./Mango.png": 210,
	"./MangoReader.png": 211,
	"./Mebooks.png": 212,
	"./Mobooks.png": 213,
	"./Monkey.png": 214,
	"./MyNovel.png": 215,
	"./Mylib.png": 216,
	"./NovelFox.png": 217,
	"./NovelHut.png": 218,
	"./NovelNow.png": 219,
	"./NovelPro.png": 220,
	"./NovelWorld.png": 221,
	"./NovelZone.png": 222,
	"./Octopus.png": 223,
	"./OrangeReader.png": 224,
	"./OwlReader.png": 225,
	"./PocketFic.png": 226,
	"./PocketeBooks.png": 227,
	"./PocketeReader.png": 228,
	"./Pocketoons.png": 229,
	"./Podfic.png": 230,
	"./PopFic.png": 231,
	"./PopNovel.png": 232,
	"./PopStories.png": 233,
	"./Pumpkin.png": 234,
	"./Rabbit.png": 235,
	"./Read4Fun-ios.png": 236,
	"./Read4Fun.png": 237,
	"./ReadNow.png": 238,
	"./Readify.png": 239,
	"./Readme.png": 240,
	"./Seagull.png": 241,
	"./Sealread.png": 242,
	"./SharkNovels.png": 243,
	"./Shepherd.png": 244,
	"./SnailReads.png": 245,
	"./StarfishFiction.png": 246,
	"./StoryHouse.png": 247,
	"./StoryRover.png": 248,
	"./StorySphere.png": 249,
	"./StorySpot.png": 250,
	"./SuperFiction.png": 251,
	"./SuperNovel.png": 252,
	"./Sweet.png": 253,
	"./TaleTrek.png": 254,
	"./TapRead.png": 255,
	"./Tellstory.png": 256,
	"./TigerReader.png": 257,
	"./Tomato.png": 258,
	"./TopFic.png": 259,
	"./Topicks.png": 260,
	"./UniFic.png": 261,
	"./VampireNovels.png": 262,
	"./WeJoy.png": 263,
	"./WeRead.png": 264,
	"./Webfiction.png": 265,
	"./Webfm.png": 266,
	"./Webnovel.png": 267,
	"./Webstories.png": 268,
	"./Whatstory.png": 269,
	"./about_bg.png": 270,
	"./android-FicFun.png": 271,
	"./appStore-check.png": 272,
	"./appStore.png": 56,
	"./app_logo.png": 120,
	"./application.png": 273,
	"./banner.png": 274,
	"./banner1.png": 275,
	"./banner2.png": 276,
	"./banner3.png": 277,
	"./basic.png": 278,
	"./bg-game.png": 279,
	"./bg.png": 280,
	"./book.png": 281,
	"./bottom-icon.png": 282,
	"./cherryfiction.png": 283,
	"./close.png": 284,
	"./contact_bg.png": 285,
	"./crazyapp.png": 286,
	"./desc.png": 287,
	"./down (1).png": 288,
	"./down.png": 289,
	"./e1.png": 290,
	"./e2.png": 291,
	"./e3.png": 292,
	"./eAudioBooks.png": 293,
	"./eReader-logo.png": 294,
	"./ereader.png": 295,
	"./fancyNovel-android.png": 296,
	"./ficfun-logo.png": 297,
	"./fj.png": 298,
	"./form_bg.png": 299,
	"./funtel-logo.png": 300,
	"./funtel.png": 301,
	"./goodfic.png": 302,
	"./goodficapp.png": 303,
	"./googlePlay-check.png": 304,
	"./googlePlay.png": 57,
	"./greatnovel.png": 305,
	"./i1.png": 306,
	"./i2.png": 307,
	"./i3.png": 308,
	"./iAudios.png": 309,
	"./iComics.png": 310,
	"./iFiction.png": 311,
	"./iNovel-ios.png": 312,
	"./iNovel.png": 313,
	"./iRomance.png": 314,
	"./iToons.png": 315,
	"./icon.png": 316,
	"./infinitytale.png": 317,
	"./iosGoodStory.png": 318,
	"./iosgoodfiction.png": 319,
	"./left.png": 320,
	"./litchifiction.png": 321,
	"./logo.png": 322,
	"./logo2.png": 323,
	"./logo3.png": 324,
	"./logo4.png": 325,
	"./logo5.png": 326,
	"./m-tel.png": 327,
	"./more.png": 328,
	"./pandareads.png": 329,
	"./peanutnovel.png": 330,
	"./phone.png": 121,
	"./pocketEbook.png": 331,
	"./qiandao.png": 332,
	"./redfic.png": 333,
	"./right.png": 334,
	"./right_bg.png": 335,
	"./romancestories.png": 336,
	"./storyfm.png": 337,
	"./theme3/shu.png": 122,
	"./theme4/banner.png": 123,
	"./theme4/people.png": 124,
	"./topstories.png": 338,
	"./ty.png": 339,
	"./web-logo.png": 340,
	"./werewolfnovels.png": 341,
	"./whatsread.png": 342
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70;